import React from "react";
import themePropTypes from "../theme-prop-types";
import Text from "./text";

const Checkbox = ({
  name,
  label,
  style,
  onChange,
  invalid,
  ariaLabel,
  ...rest
}) => (
  <label
    className={`checkbox-wrapper-web-sdk ${rest?.checked ? "selected" : ""} ${
      invalid ? "invalid" : ""
    }`}
    data-testid={`checkbox-wrapper-${name}`}
    htmlFor={name}
  >
    <input
      id={name}
      type='checkbox'
      onChange={onChange}
      data-testid={`checkbox-${name}`}
      aria-label={ariaLabel || name}
      {...rest}
    />
    <span className='checkbox-input-web-sdk' />
    {label ? (
      <span
        className='checkbox-text-wrapper-web-sdk'
        aria-hidden={Boolean(ariaLabel)}
      >
        {" "}
        <Text label={label} name={name} isSpan />{" "}
      </span>
    ) : (
      ""
    )}
  </label>
);
Checkbox.propTypes = themePropTypes.checkbox;

export default Checkbox;
